import React, { useEffect, useState } from 'react'
import PercentageRangeSlider from 'components/PercentageRangeSlider'
import styled from 'styled-components'
import { COLORS } from 'theme'
import { Form as AntdForm } from 'antd'
import Select from 'components/Select'

export const StyledHeading = styled.h2`
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 21px;
  margin: 15px;
  color: ${props => (props.color ? props.color : COLORS.BLACK)};
`
export const FormItem = styled(AntdForm.Item)`
  margin-bottom: 0px !important;
  margin-right: 14px !important;
`

const SalaryFilter = ({ setFilters, filters, currentUrl }) => {
  const getInitialValues = () => {
    if (currentUrl && currentUrl.includes('minCTC') && currentUrl.includes('maxCTC')) {
      const params = new URLSearchParams(currentUrl);
      const start = parseInt(params.get('minCTC'), 10) / 100000; // Divide by 1 lakh
      const end = parseInt(params.get('maxCTC'), 10) / 100000; // Divide by 1 lakh
      return [start, end];
    }
    return [0, 100]; // Default values
  };

  const [minValue, setMinValue] = useState(getInitialValues()[0]);
  const [maxValue, setMaxValue] = useState(getInitialValues()[1]);
  
  useEffect(() => {
    setFilters({
      ...filters,
      minCTC: minValue * 100000,
      maxCTC: maxValue * 100000,
    })
  }, [minValue, maxValue])

  const onMinValueChange = val => {
    setMinValue(val)
  }
  const onMaxValueChange = val => {
    setMaxValue(val)
  }

  const currencyOptions = [
    {
      id: '1',
      name: 'All Currency',
      value: 'All',
    },
  ]
  return (
    <>
      <StyledHeading>Salary</StyledHeading>
      <StyledHeading color={COLORS.BLACK_WHITE_B_50}>
        {minValue}LPA - {maxValue}LPA
      </StyledHeading>

      <PercentageRangeSlider
        minValue={minValue}
        setMinValue={onMinValueChange}
        maxValue={maxValue}
        setMaxValue={onMaxValueChange}
        LPA={true}
      />
      <div>
        <FormItem
          name="currency"
          rules={[{ required: true, message: 'Please enter degree name!' }]}
        >
          <Select
            label="Select Currency *"
            valueParam={'value'}
            placeholder="Eg. Bachlore of Engineering - B.E"
            OptionData={currencyOptions}
            optionLabelProp="name"
            defaultValue="All Currency"
          />
        </FormItem>
      </div>
    </>
  )
}

export default SalaryFilter
